var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcsL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34388 8.98367C1.38747 11.0273 1.40926 12.0492 2.16334 12.8061C2.91743 13.5631 3.96693 13.5895 6.06593 13.6422C7.35958 13.6747 8.64051 13.6747 9.93418 13.6422C12.0332 13.5895 13.0826 13.5631 13.8367 12.8061C14.5908 12.0492 14.6126 11.0273 14.6562 8.98367C14.6702 8.32654 14.6702 7.67327 14.6562 7.01621C14.6126 4.97249 14.5908 3.95065 13.8367 3.19369C13.0826 2.43674 12.0332 2.41037 9.93418 2.35763C8.64051 2.32513 7.35958 2.32513 6.06592 2.35763C3.96693 2.41036 2.91743 2.43673 2.16334 3.19369C1.40926 3.95064 1.38746 4.97249 1.34388 7.01614C1.32987 7.67327 1.32987 8.32654 1.34388 8.98367Z",
    fill: "#3D4AF5",
    stroke: "#3D4AF5",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 5.66663L6.62797 6.82623C7.77143 7.50229 8.22849 7.50229 9.37196 6.82623L11.3333 5.66663",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcsL);
export default __webpack_public_path__ + "static/media/email_ics_l.7a4404770a3f26da17eb647d762888c5.svg";
export { ForwardRef as ReactComponent };